module.exports = __webpack_public_path__ + "static/contact-us-32eaba805225e451d723c58b42b74a50.jpg";